import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { MovieState } from "../movieState";
// Animations
import { motion } from "framer-motion";
import { pageAnimation } from "../animation";
import ScrollTop from "../components/ScrollTop";

const Details = styled(motion.div)`
  color: #fff;
`;

const Headline = styled.div`
  min-height: 90vh;
  padding-top: 20vh;
  position: relative;
  h2 {
    position: absolute;
    top: 10%;
    left: 50%;
    transform: translate(-50%, -10%);
  }
  img {
    width: 100%;
    height: 70vh;
    object-fit: cover;
  }
  /* Kindel and iPad tablet  */
  @media only screen and (min-width: 540px) and (max-width: 820px) {
    min-height: fit-content;
  }
`;
const Awards = styled.div`
  min-height: 80vh;
  display: flex;
  margin: 5rem 10rem;
  align-items: center;
  justify-content: space-around;
  /* Kindel and iPad tablet  */
  @media only screen and (min-width: 540px) and (max-width: 820px) {
    min-height: fit-content;
    margin: 0;
    flex-direction: column;
  }
`;

const AwardStyle = styled.div`
  padding: 5rem;
  h3 {
    font-size: 1.7rem;
    font-weight: 500;
  }
  .line {
    width: 100%;
    background: #FFE347;
    height: 0.5rem;
    margin: 1rem 0;
  }
  p {
    padding: 2rem 0;
    font-size: 1.2em;
    font-weight: 300;
  }
`;

const ImageDisplay = styled.div`
  min-height: 50vh;
  img {
    width: 100%;
    height: 100vh;
    object-fit: cover;
  }
  /* Kindel and iPad tablet  */
  @media only screen and (min-width: 540px) and (max-width: 820px) {
    min-height: fit-content;
    img {
      min-height: 10vh;
      height: 40vh;
    }
  }
`;

// Award Component
const Award = ({ title, description }) => {
  return (
    <AwardStyle>
      <h3>{title}</h3>
      <div className="line"></div>
      <p>{description}</p>
    </AwardStyle>
  );
};

const MovieDetail = () => {
  const history = useHistory();
  const url = history.location.pathname;
  console.log(url);
  const [movies] = useState(MovieState);
  const [movie, setMovie] = useState(null);

  useEffect(() => {
    const currentMovie = movies.filter((stateMovie) => stateMovie.url === url);
    setMovie(currentMovie[0]);
  }, [movies, url]);

  return (
    <Details
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      {movie ? (
        <div>
          <Headline>
            <h2>{movie.title}</h2>
            <ImageDisplay>
              <img src={movie.mainImg} alt="movie" />
            </ImageDisplay>
          </Headline>
          <Awards>
            {movie.awards.map((award, index) => (
              <Award
                key={index}
                title={award.title}
                description={award.description}
              />
            ))}
          </Awards>
          <ImageDisplay>
            <img src={movie.secondaryImg} alt="movie" />
          </ImageDisplay>
        </div>
      ) : (
        <h3>Sorry the movie you are looking is not available</h3>
      )}
      <ScrollTop />
    </Details>
  );
};

export default MovieDetail;
